import { render, staticRenderFns } from "./GoldCoast.vue?vue&type=template&id=ed0acd76&scoped=true"
import script from "./GoldCoast.vue?vue&type=script&lang=js"
export * from "./GoldCoast.vue?vue&type=script&lang=js"
import style0 from "./GoldCoast.vue?vue&type=style&index=0&id=ed0acd76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0acd76",
  null
  
)

export default component.exports